(function() {
  "use strict";

// var a = [
  // {
  //     origin:"SHJ",
  //     destination: "CMB",
  //     split_state: 'Y', 
  //     records: [
  //         {
  //             fromDate: "05/08/2011",
  //             toDate: "07/08/2018",
  //             msv: "0.021", 
  //         },
  //         {
  //             fromDate: "05/08/2011",
  //             toDate: "07/08/2018",
  //             msv: "0.025", 
  //         }
  //     ] 
  // },
//   {
//       origin:"CMB",
//       destination: "SHJ",
//       split_state: 'Y', 
//       records: [
//           {
//               fromDate: "05/08/2011",
//               toDate: "07/08/2018",
//               msv: "0.028", 
//           },
//           {
//               fromDate: "05/08/2011",
//               toDate: "07/08/2018",
//               msv: "0.029", 
//           }
//       ]  
//   }]

  /**
   * @ngdoc service
   * @name cosmicRadiation.service:searchCosmicRadiation
   *
   * @description
   *
   */
  angular
    .module("cosmicRadiation")
    .service("SearchCosmicRadiationService", searchCosmicRadiation);

  function searchCosmicRadiation(
    RemoteService,
    CommonMasterData,
    applicationConstants,
    CosmicRadiationService
  ) {
    var self = this;


    self.searchCosmicRadiationValues = function(searchParams, successFn, errorFn) {
      console.log("searchParams: ", searchParams)

      var paramData = {
        "origin": searchParams.origin.value ? searchParams.origin.value.airPortCode : "",
        "destination": searchParams.destination.value ? searchParams.destination.value.airPortCode : "",
        "validFrom": searchParams.fromDate.value || "",
        "validTo": searchParams.toDate.value || "",
        "exposureMin": searchParams.mSvFrom.value,
        "exposureMax": searchParams.mSvTo.value,
        "pageSize": 300,
        "startPosition": 1
      };
      RemoteService.searchCosmicRadiationValues(paramData).then(
        function(response) {
          /*  Should be function data adapter from the CosmicRadiationFactory here */
          // var airportCats = AirportFactory.formatAirportCategorySearchResponse(
          //   response.airportCaCosmicRadiationServicetegories
          // );

          var sorted = response.data.sort(function(a, b) {
            return (a.origin + '/' + a.destination < b.origin + '/' + b.destination) ? -1 : 0;
          })

          var data = {};

          for (let i = 0, l = sorted.length; i < l; i++) {
            var elem = sorted[i];
            var key = elem.origin + "/" + elem.destination;

            if (!data[key]) {
              data[key] = {
                origin: elem.origin,
                destination: elem.destination,
                records: [
                  {
                    id: elem.id,
                    validFrom: moment(elem.validFrom, "YYYY-MM-DD").format("DD/MM/YYYY"),
                    validTo: moment(elem.validTo, "YYYY-MM-DD").format("DD/MM/YYYY"),
                    exposure: elem.exposure
                  }
                ]
              };
            } else {
              data[key].records.push({
                id: elem.id,
                validFrom: moment(elem.validFrom, "YYYY-MM-DD").format("DD/MM/YYYY"),
                validTo: moment(elem.validTo, "YYYY-MM-DD").format("DD/MM/YYYY"),
                exposure: elem.exposure
              });
            }
            data[key].records.sort(function(a, b) {
              return moment(a.validTo, "DD/MM/YYYY").diff(moment(b.validTo, "DD/MM/YYYY"));
            });
          }

          CosmicRadiationService.setAllCosmicRadiation(Object.values(data));
          successFn(response.data);
        },
        function(error) {
          console.log(error)
          errorFn(error.msg[0]);
        }
      );
    };
  }
})();
